import { gsap } from "gsap";
import { SplashView } from '../SplashController';
import { SanJumpData } from '../../../server/base/IData';
import { IDimOrientation, ResizeHelper } from "../../../../core/utils/ResizeHelper";
import { Sequence } from "../../../../core/displayobject/Sequence";
import { SpinePlayer } from "../../../../core/displayobject/SpinePlayer";
import { SanQuentin2 } from "../../../SanQuentin2";
import { TranslationConfig } from "../../../config/translate/TranslationConfig";
import { TextStyleConfig } from "../../../config/translate/TextStyleConfig";
import { Helper } from "../../../../core/utils/Helper";
import { GameData } from "../../../server/data/GameData";
import { GameSetting } from "../../../../core/setting/GameSetting";
import { SoundManager } from "../../../config/sound/SoundManager";
import { SoundConfig } from "../../../config/sound/SoundConfig";

export interface totalPresentationJWFS {
    jwData: SanJumpData[];
    fs: number;
}

export class SplashTotalWin extends PIXI.Container implements SplashView {

    initiated: boolean = false;

    protected readonly layoutDim: IDimOrientation = {
        landscape: {
            scale: new PIXI.Point(1, 1),
            position: new PIXI.Point(0, -200),
        },
        portrait: {
            scale: new PIXI.Point(1, 1),
            position: new PIXI.Point(0, -200)
        }
    };

    private _txt_FS: PIXI.Text;
    private _txt_TOTAL: PIXI.Text;

    private fsOutroSpineBoard: SpinePlayer;

    private isBelowStake: boolean;

    protected _timeLine: gsap.core.Timeline;
    private lastJwData: SanJumpData[] = [];

    protected _gfxBg: PIXI.Graphics;

    constructor() {
        super();
    }

    setData(data: GameData) {
        if (!this.initiated) this.initAnimations();
        this.lastJwData = data.Reel.jumpData;

        this.isBelowStake = data.Win.isWinBelowStake!();
        this._txt_FS.text = GameSetting.translate(TranslationConfig.FREESPINS_PLAYED) + "\n" + data.raw.numberOfFreespinsPlayed;

        this._txt_TOTAL.text = (!this.isBelowStake ? GameSetting.translate(TranslationConfig.TOTAL_WIN) : "") + "\n" + SanQuentin2.apiPlugin.currency.formatValue(data.Win.totalWin);

    }

    protected createGraphic(): void {
        const maxAreaSize: number = 3000;
        this._gfxBg = this.addChild(new PIXI.Graphics());
        this._gfxBg.beginFill(0x000000, 0.65);
        this._gfxBg.drawRect(-maxAreaSize * 0.5, -maxAreaSize * 0.5, maxAreaSize, maxAreaSize);
        this._gfxBg.endFill();
    }

    protected initAnimations(): void {
        this.createGraphic();

        this.fsOutroSpineBoard = this.addChild(new SpinePlayer("total_win_board"));

        this._txt_FS = this.createText(GameSetting.translate(TranslationConfig.COLLECTED_JUMPING_WILDS));
        this._txt_FS.style = TextStyleConfig.COLLECT_TEXT;
        this._txt_FS.style.align = "center";

        this._txt_TOTAL = this.createText(GameSetting.translate(TranslationConfig.TOTAL_WIN));
        this._txt_TOTAL.style = TextStyleConfig.TOTAL_WIN;
        this._txt_TOTAL.style.align = "center";
        this._txt_TOTAL.position.y = 300;

        this.visible = false;
        this.initiated = true;
        this.onResize();
    }

    private createText(val: string): PIXI.Text {
        const temp: PIXI.Text = new PIXI.Text(GameSetting.translate(val));
        temp.style = TextStyleConfig.BONUS_RESULT_TEXT;
        temp.anchor.set(0.5, 0.5);
        this.addChild(temp);
        return temp;
    }

    public play(): gsap.core.Timeline {
        if (!this.initiated) this.initAnimations();
        this.onResize();

        this._timeLine = Helper.setTimeline(this._timeLine, {
            onStart: () => {
                this.visible = true;
                this.alpha = 1;
            }
        });

        this.fsOutroSpineBoard.visible = false;
        this._timeLine.add(this.fsOutroSpineBoard.play({
            animation: "show", showOnEnd: true,
            onComplete: () => {
                this.fsOutroSpineBoard.play(
                    { animation: "jw_" + (this.lastJwData.length ? this.lastJwData.length : 1), showOnEnd: true });
            }
        }))

        this._timeLine.add(() => {
            SoundManager.PlayAmbience(SoundConfig.FS_OUTRO);
        }, 0.423)

        this._timeLine.fromTo([this._txt_FS, this._txt_TOTAL], { alpha: 0 }, { duration: 0.3, alpha: 1 }, 0);

        // this._timeLine.add(() => {
        //     if(!this.isBelowStake){
        //         SoundManager.playSoundEffect("winLarge");
        //     }
        // });

        return this._timeLine;
    }

    public stop(): gsap.core.Timeline {
        this._timeLine = Helper.setTimeline(this._timeLine, {
            onComplete: () => {
                this.visible = false;
            }
        });
        this._timeLine.to(this, 0.35, { alpha: 0 });
        return this._timeLine;
    }

    public onResize(): void {

        this._txt_FS.y = ResizeHelper.isLandscape ? 0 : -25;

        this.position = ResizeHelper.calcDim(this.layoutDim).position;
        this.scale = ResizeHelper.calcDim(this.layoutDim).scale;

        this._txt_FS.style.fontSize = 72;
        this._txt_TOTAL.style.fontSize = 72;

        if (ResizeHelper.isLandscape) {
            this.fsOutroSpineBoard.scale.set(0.75, 0.75);
            this.fsOutroSpineBoard.position.y = 175;

            this._txt_FS.position.set(-106, 20);
            this._txt_TOTAL.position.y = 240;

        } else {
            this.fsOutroSpineBoard.scale.set(1);
            this.fsOutroSpineBoard.position.y = 100;

            this._txt_FS.position.set(-130, -100);
            this._txt_TOTAL.position.y = 180;
        }

        this._txt_TOTAL.style.fontSize = this._txt_FS.style.fontSize = 72;
        this._txt_TOTAL.scale = this._txt_FS.scale = this.fsOutroSpineBoard.scale;

        while (this._txt_FS.width >= 260 * this.fsOutroSpineBoard.scale.x) this._txt_FS.style.fontSize--;
        while (this._txt_TOTAL.width >= 500 * this.fsOutroSpineBoard.scale.x) this._txt_TOTAL.style.fontSize--;

        if (this._timeLine && this._timeLine.isActive()) this._timeLine.progress(1);
    }
}
